import { useState } from 'react';
import type { Eu } from '@bi-evox/contrato';
import { ErroApi, obter, token } from '../api/cliente';

export function Login() {
  const [valor, setValor] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  return (
    <div className="login">
      <form
        onSubmit={async (e) => {
          e.preventDefault();
          setEnviando(true);
          setErro(null);
          try {
            await obter<Eu>('/v1/eu', undefined, valor.trim());
            token.gravar(valor.trim());
          } catch (err) {
            setErro(err instanceof ErroApi && err.status === 401 ? 'Token não confere.' : 'Não consegui falar com o servidor.');
          } finally {
            setEnviando(false);
          }
        }}
      >
        <h1>
          BI <span>Evox</span>
        </h1>
        <p className="mudo">Painel da operação 99Play. Entre com o token de acesso.</p>
        <label>
          Token
          <input type="password" autoComplete="current-password" value={valor} onChange={(e) => setValor(e.target.value)} required />
        </label>
        {erro && (
          <p className="erro-texto" role="alert">
            {erro}
          </p>
        )}
        <button type="submit" disabled={enviando || !valor.trim()}>
          {enviando ? 'Conferindo…' : 'Entrar'}
        </button>
      </form>
    </div>
  );
}
